var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my-4"},[_c('UiTable',{attrs:{"data":_vm.data,"config":_vm.extraConfig,"is-loading":false,"fixed-header":"","height":"227px"},scopedSlots:_vm._u([{key:"currency",fn:function(ref){
var row = ref.row;
return [_c('span',[_vm._v(_vm._s(row.currencyCode))])]}},{key:"amount",fn:function(ref){
var row = ref.row;
return [_c('span',[_vm._v(" "+_vm._s(row.amount)+" "),_c('span',{staticClass:"text--secondary"},[_vm._v(_vm._s(row.currencyCode))])])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }